/*
* Created on Jan 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import React from 'react';
import ic_util_more_svg from '../../static/img/header/ic-util-more.svg'
import useToggle from "../../hook/ToggleHook";
import {convertToQNAPLang, GET_CMS_URL, GET_SERVICE_STATUS_URL} from "../../service/common";
import {useTranslation} from "react-i18next";
import {useRegion} from "../../context/RegionContext";

const HeaderUtilMoreComponent = () => {
    const {t, i18n} = useTranslation();
    const {region, url} = useRegion();
    const [open, node] = useToggle();

    return (
        <div className="util-btn util-more" ref={node}>
            <div className={"comp-dropdown " + open}>
                <ul className="comp-dropdown-menu overlay-scroll">
                    <li className="section">
                        <div className="section-head">{t('@Support@')}</div>
                        <div className="section-items selection" onClick={() => window.open(`${url.get_qnap_url()}/go/software/organization-center`, '_blank')}>{t('@Features@')}</div>
                        <div className="section-items selection" onClick={() => window.open(`https://support.myqnapcloud.com/faq?lang=${i18n.language}`, '_blank')}>{t('@FAQ@')}</div>
                        <div className="section-items selection" onClick={() => window.open(`${url.get_service_status_url()}/service_status?lang=${i18n.language}`, '_blank')}>{t('@System Status@')}</div>
                        <div className="section-items selection" onClick={() => window.open(`${url.get_qnap_url()}/${convertToQNAPLang(i18n.language)}/support-ticket/`, '_blank')}>{t('@Contact us@')}</div>
                    </li>
                    {region !== 'CHINA' && <>
                        <li className="section-divide"/>
                        <li className="section">
                            <div className="section-head">{t('@Community@')}</div>
                        <div className="section-items selection" onClick={()=>window.open(`${window._env_.REACT_APP_FORUM_URL}`, '_blank')}>{t('@Forum@')}</div>
                    </li>
                    </>}
                    <li className="section-divide" />
                    <li className="section">
                        <div className="section-head">QNAP</div>
                        <div className="section-items selection" onClick={()=>window.open(`${url.get_qnap_url()}/${convertToQNAPLang(i18n.language)}`, '_blank')}>{t('@QNAP official website@')}</div>
                        <div className="section-items selection" onClick={()=>window.open(`${url.get_qnap_url()}/${region === 'CHINA' ? 'zh-cn' : 'go'}/legal/qnap-privacy-policy`, '_blank')}>{t('@Privacy policy@')}</div>
                        <div className="section-items selection" onClick={()=>window.open(`${url.get_qnap_url()}/${convertToQNAPLang(i18n.language)}/before_buy/con_show.php?op=showone&cid=15`, '_blank')}>{t('@Terms of service@')}</div>
                        <div className="section-items selection" onClick={()=>window.open(`${url.get_qnap_support_url()}/security?lang=${i18n.language}`, '_blank')}>{t('@Security Disclaimer@')}</div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default HeaderUtilMoreComponent;